'use client';

import React from 'react';
import { RevshareTransaction } from '../types';
import { CalendarIcon } from '../../../../components/icons';
import { useTranslations } from '../../../../contexts/translation.context';

interface DateCellProps {
  transaction: RevshareTransaction;
}

const DateCell: React.FC<DateCellProps> = ({ transaction }) => {
  const { lang } = useTranslations();

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString(lang === 'ru' ? 'ru-RU' : 'en-US', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };

  const formatTime = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString(lang === 'ru' ? 'ru-RU' : 'en-US', {
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  // Calculate time ago
  const getTimeAgo = (dateString: string) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffMins = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffDays > 0) {
      const hours = diffHours % 24;
      return lang === 'ru' ? `${diffDays}д. ${hours}ч. назад` : `${diffDays}d ${hours}h ago`;
    }
    if (diffHours > 0) {
      const mins = diffMins % 60;
      return lang === 'ru' ? `${diffHours}ч. ${mins}мин. назад` : `${diffHours}h ${mins}min ago`;
    }
    if (diffMins > 0) {
      return lang === 'ru' ? `${diffMins}мин. назад` : `${diffMins}min ago`;
    }
    return lang === 'ru' ? 'только что' : 'just now';
  };

  const timeAgo = getTimeAgo(transaction.created_at);

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-1 text-auth-muted text-xs">
        <CalendarIcon size={14} />
        <span>{timeAgo}</span>
      </div>
      <div className="text-auth-muted text-xs">
        {formatDate(transaction.created_at)} {formatTime(transaction.created_at)}
      </div>
    </div>
  );
};

export default DateCell;
